import { useContext } from 'react'
import { HealthCtx } from './health-state'

export function useHealth() {
  return useContext(HealthCtx)
}
